const validatorRegex = '^[a-z0-9-]{1,63}\\.[a-z0-9-]{1,63}\\.(&domains)$';

const thirdLevelDomainValidator = (
  domain,
  domains = ['com', 'org', 'net', 'edu', 'gov', 'info', 'biz'],
  isRequired = true,
  text = 'The specified domain must end with either .com, .org, .net, .edu, .gov, .info or .biz',
) => {
  if (!domain && isRequired) {
    return 'Required';
  }
  return new RegExp(
    validatorRegex.replace('&domains', domains.join('|')),
    'g',
  ).test(domain)
    ? undefined
    : text;
};

export default thirdLevelDomainValidator;
